import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

const FALLBACK = {
  stats: [
    { id: "creators", number: "15+", label: "CREATOR" },
    { id: "revenue", number: "Top 1%", label: "POSIZIONAMENTO CREATOR" },
    { id: "team", number: "20+", label: "MEMBRI DEL TEAM" },
    { id: "operations", number: "24/7", label: "OPERATIVITÀ CHAT & SALES" },
  ],
  whatsapp_url: "https://wa.me/393287116258",
};

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState(FALLBACK);
  const [contactOpen, setContactOpen] = useState(false);
  const [contactIntent, setContactIntent] = useState("creator");
  const [token, setToken] = useState(() => localStorage.getItem("iem_token"));

  const refreshSettings = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      if (data && data.stats) setSettings(data);
    } catch (e) {
      /* fallback values remain */
    }
  }, []);

  useEffect(() => {
    refreshSettings();
  }, [refreshSettings]);

  const openContact = (intent = "creator") => {
    if (intent === "creator") {
      window.open(settings.whatsapp_url, "_blank", "noopener,noreferrer");
      return;
    }
    setContactIntent(intent);
    setContactOpen(true);
  };
  const login = (t) => {
    localStorage.setItem("iem_token", t);
    setToken(t);
  };
  const logout = () => {
    localStorage.removeItem("iem_token");
    setToken(null);
  };

  return (
    <SiteContext.Provider
      value={{ settings, refreshSettings, contactOpen, setContactOpen, contactIntent, openContact, token, login, logout }}
    >
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
